import { render } from "./Drawers.vue?vue&type=template&id=782634da&ts=true"
import script from "./Drawers.vue?vue&type=script&lang=ts"
export * from "./Drawers.vue?vue&type=script&lang=ts"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__